//
//
//
//
//
//
//
//
//
//
//
//
//
import { isCopyToClipboardSupported, copyToClipboard } from '@/utils/vuex';
export default {
  name: 'CustomTextFieldClipboard',
  props: {
    readOnly: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    isCopySupported: function isCopySupported() {
      return isCopyToClipboardSupported();
    }
  },
  methods: {
    ripple: function ripple() {
      var $el = this.$refs.element.$el;
      var ev = new Event('mousedown');
      var offset = $el.getBoundingClientRect();
      ev.clientX = offset.left + offset.width / 2;
      ev.clientY = offset.top + offset.height / 2;
      $el.dispatchEvent(ev);
      this.$nextTick(function () {
        $el.dispatchEvent(new Event('mouseup'));
      });
    },
    selectInputValue: function selectInputValue() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs.element.$refs.input.select();
      });
    },
    handleClick: function handleClick(event) {
      event.stopPropagation();
      this.selectInputValue();
      copyToClipboard(this.$attrs.value);
    },
    handleClickAppend: function handleClickAppend(event) {
      event.stopPropagation();
      this.ripple();
      this.selectInputValue();
      copyToClipboard(this.$attrs.value);
    }
  }
};